import { render, staticRenderFns } from "./RegistrationWarning.vue?vue&type=template&id=d4baffcc"
import script from "./RegistrationWarning.vue?vue&type=script&lang=js"
export * from "./RegistrationWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports